import {
  BalanceText,
  Button,
  Icon,
  IconButton,
  Shadow,
  Text,
  HStack,
  VStack,
} from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import {
  TableContentItemBadge,
  TableContentItemCaptions,
} from '../../../../../../components/TableContent';
import { messageError } from '../../../../../../store/batchTicket/constants';
import { mapCaptions } from '../../../../utils';
import { ItemTag } from '../../../Customer/components/ItemTag';

import { getOffersQuantityText } from './constants';

import { TotalSummaryResponsiveItem } from '.';

export const TotalSummaryItemDesktop: React.FC<TotalSummaryResponsiveItem> = ({
  handleRemoveCustomer,
  handleDetailsCustomer,
  handleExportItem,
  handleUpdateBalance,
  isLoadingBalance,
  item,
  detailsBasketItemButtonIsDisabled,
  availableBalance,
  allocatedBalanceField,
  remainingBalanceField,
}) => {
  return (
    <Shadow borderRadius={BoxRadius.xs} level={2}>
      <HStack
        p={Spacing['inline.xxs']}
        alignItems="center"
        borderRadius={BoxRadius.xs}
        justifyContent="space-between">
        <VStack space={Spacing['stack.quarck']}>
          <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
            Nome
          </Text>
          <Text
            noOfLines={2}
            width="200px"
            fontSize={Typography['fontsize.md']}
            color="neutral.darkest">
            {item?.customer?.customerName || messageError}
          </Text>
          <HStack space={Spacing['inline.nano']} alignItems="center">
            <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
              Conta
            </Text>
            <Text fontSize={Typography['fontsize.xs']} color="neutral.dark">
              {item?.customer?.account?.accountNumber || messageError}
            </Text>
            <TableContentItemCaptions forceDesktop icons={mapCaptions(item?.customer || [])} />
          </HStack>
        </VStack>
        <VStack space={Spacing['stack.quarck']}>
          <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
            Suitability
          </Text>
          <TableContentItemBadge>
            {item?.customer?.suitabilityProfileName || 'conservador'}
          </TableContentItemBadge>
        </VStack>
        <VStack space={Spacing['stack.quarck']} w="120px">
          <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
            Hashtag
          </Text>
          <ItemTag
            isListing
            data={(item?.customer?.hashtags as never) || []}
            itemId={item?.customer?.account?.accountNumber}
          />
        </VStack>
        <VStack space={Spacing['stack.quarck']}>
          <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
            Ativos adicion.
          </Text>
          <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.darkest">
            {getOffersQuantityText(item?.totalCustomerOffers)}
          </Text>
        </VStack>
        <VStack space={Spacing['stack.quarck']}>
          <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
            Saldo disponível
          </Text>
          <BalanceText
            balance={availableBalance}
            lastUpdatedAt={new Date()}
            isUpdating={isLoadingBalance}
            textAlign="flex-start"
            hasUpdateButton
            onUpdateButtonPress={handleUpdateBalance}
            positiveBalanceColor="neutral.black"
            negativeBalanceColor="feedback.error.default"
          />
        </VStack>
        <VStack space={Spacing['stack.quarck']}>
          <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
            Saldo alocado | %
          </Text>
          <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.darkest">
            {allocatedBalanceField}
          </Text>
        </VStack>
        <HStack alignItems={'center'} space={Spacing['inline.xxs']}>
          <VStack space={Spacing['stack.quarck']} alignItems={'flex-end'}>
            <Text fontSize={Typography['fontsize.md']} color="neutral.black" variant="semibold">
              Saldo restante | %
            </Text>
            <Text noOfLines={1} fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {remainingBalanceField}
            </Text>
          </VStack>
          {handleRemoveCustomer && (
            <IconButton
              testId="remove-icon-button"
              borderRadius={BoxRadius.sm}
              icon="Trash"
              onPress={handleRemoveCustomer}
              p={0}
              iconColor={Color['feedback.error.default']}
              iconSize="xs"
            />
          )}
          {handleDetailsCustomer && (
            <IconButton
              isDisabled={detailsBasketItemButtonIsDisabled}
              testId="details-icon-button"
              borderRadius={BoxRadius.sm}
              icon="ChevronRight"
              onPress={handleDetailsCustomer}
              p={0}
              iconColor={Color['brand.primary.principal']}
              iconSize="xs"
            />
          )}
          {handleExportItem && (
            <Button
              variant="textLink"
              onPress={handleExportItem}
              leftIcon={<Icon name="Pdf" size="xxxs" color={Color['brand.tertiary.principal']} />}
              _text={{
                fontFamily: Typography['fontfamily.base.semibold'],
                color: 'brand.tertiary.principal',
              }}>
              Exportar
            </Button>
          )}
        </HStack>
      </HStack>
    </Shadow>
  );
};
